import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import isMobileDevice from "../../utils/isMobile";
import { ChatMode } from "../../types/chatConfig";

export interface IChatbotState {
  isEnded: boolean;
  isMaximised: boolean;
  isIntroScreenClosed: boolean;
  isInitialized: boolean;
  isChildReady: boolean;
  isMobile: boolean;
  isSurveyVisible: boolean;
  isVoiceInputVisible: boolean;
  isProcessing: boolean;
}

const initialState: IChatbotState = {
  isEnded: false,
  isMaximised: false,
  isIntroScreenClosed: false,
  isInitialized: false,
  isChildReady: false,
  isMobile: isMobileDevice(),
  isSurveyVisible: false,
  isVoiceInputVisible: false,
  isProcessing: false,
};

const chatbotSlice = createSlice({
  name: "chatbot",
  initialState,
  reducers: {
    toggleMaximise: (state) => {
      state.isMaximised = !state.isMaximised;
    },
    initializeChat: (state) => {
      state.isInitialized = true;
    },
    updateChildFrameState: (state) => {
      state.isChildReady = true;
    },

    closeIntroScreen: (state) => {
      state.isIntroScreenClosed = true;
    },
    restartChat: (state) => {
      state.isIntroScreenClosed = false;
      state.isEnded = false;
      state.isSurveyVisible = false;
      state.isChildReady = false;
    },
    endChat: (state, action: PayloadAction<ChatMode>) => {
      state.isEnded = true;
      if (action.payload === "VOICE") {
        window.location.reload();
      }
    },
    showSurvey: (state) => {
      state.isSurveyVisible = true;
    },
    maximiseChat: (state) => {
      state.isMaximised = true;
    },
    minimiseChat: (state) => {
      state.isMaximised = false;
    },
    toggleVoiceInput: (state, action: PayloadAction<boolean | undefined>) => {
      state.isVoiceInputVisible = typeof action.payload === "undefined" ? !state.isVoiceInputVisible : action.payload;
    },
    setIsProcessing: (state, { payload }: PayloadAction<boolean>) => {
      state.isProcessing = payload;
    },
  },
});

export const { toggleMaximise, initializeChat, updateChildFrameState, closeIntroScreen, endChat, showSurvey, maximiseChat, minimiseChat, toggleVoiceInput, restartChat, setIsProcessing } = chatbotSlice.actions;

export default chatbotSlice.reducer;
